
		<ng-container *ngIf="canViewPage()">
			<app-navbar *ngIf="isLogged"></app-navbar>
			<router-outlet></router-outlet>
			<app-navbar-bottom *ngIf="isLogged"></app-navbar-bottom>
		</ng-container>
	